import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { BackgroundImage } from "../../elements";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import PrimaryButton from "../../elements/primary-button";
import Swiper from 'swiper';
import { gtag } from "../../utils";

import "./style.scss";
const Modeldisplay = ({ page, lang, rendering, fields }) => {
  const  {
		pc_title,
		pc_subtitle,
		m_title,
		m_subtitle,
		pc_background_image,
		m_background_image,
		list,
		hand_icon,
		left_right_icon,
		tips,
		dragtext
	} = fields
  const rootEl = useRef();
  const swiper = useRef(null)
  const swiperEl = useRef(null)
  const isMobile = mobileIs()
  const [swiperIndex, setSwiperIndex] = useState(0)
  const [isShow, setIsShow] = useState(true)
  const [clickState, setClickState] = useState(false)
  const [showDrag, setShowDrag] = useState(false)
  const [isActive, setIsActive] = useState(false)
  let [downX, setDownX] = useState(0)
  const rootNode = useRef(null)
  const isAR = page?.fields?.rtl?.value;
  const getCurrentArrDefault = () => {
    let newArr = [];
    (list || []).map(item => {
      newArr.push(0);
      return null;
    });
    return newArr;
  }
  const [currentArr, setCurrentArr] = useState(() => getCurrentArrDefault())

  const buildSwiper = () => {
    const options = {
      watchSlidesProgress: true,
      slidesPerView: isMobile ? 1 : 1.5,
      spaceBetween: 0,
      loop: list.length > 1,
      centeredSlides: true,
      on: {
        transitionEnd(swiper) {
          let realIndex = swiper.realIndex
          setSwiperIndex(realIndex)
          if(realIndex !== 0 && isShow) {
            setIsShow(false)
          }
        }
      }
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  const changeCarType = (e, index) => {
    gtag('event', 'Component_info', {
      'component_name': 'Modeldisplay',
      'page_title': page?.name
    });
    setIsShow(false)
    let newArr = JSON.parse(JSON.stringify(currentArr))
    newArr[swiperIndex] = index
    setCurrentArr(newArr)
  }

  useEffect(() => {
    if (swiper.current && !isMobile) {
      swiper.current.destroy(true, true)
      buildSwiper()

      let index = 0
      if(swiperIndex === 0 && list.length < 3) {
        index = swiperIndex + list.length
      } else {
        index = swiperIndex + 2
      }
			if(list.length > 1) {
				swiper.current.slideTo(index, 0, false)
			}
    }
		
		if (swiper.current && isMobile) {
		  swiper.current.destroy(true, true)
		  buildSwiper()
			
		  let index = swiperIndex + 1
			if(list.length > 1) {
				swiper.current.slideTo(index, 0, false)
			}
		}
  }, [currentArr]);

  // 鼠标点击
  const mousedown = (e) => {
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX)
    setDownX(eventX)
    setClickState(true)
  }

  // 鼠标释放
  const mouseup = (e) => {
    setClickState(false)
  }

  // 鼠标移动
  const mousemove = (e) => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    const eventY = e.clientY || (e.touches && e.touches[0]?.clientY) || 0
    
    let domOffsetTop = rootEl.current?.getBoundingClientRect()?.top
    let dom = document.querySelector('.drag-content')
    let top = 0
    if(eventY - 60 - domOffsetTop < 0) {
      top = 0
    } 
    else if(eventY - domOffsetTop > pageHeight - 60) {
      top = pageHeight - 120
    } 
    else {
      top = eventY - 60 - domOffsetTop
    }
    dom.style.top = top  + 'px'
    dom.style.left = eventX - 60 + 'px'

    if(!clickState) return null
    if(eventX-downX < -100) { //切换到下一个
      setClickState(false)
			if(list.length > 1) {
				if(isAR) {
				  swiper.current.slidePrev()
				} else {
				  swiper.current.slideNext()
				}
			}
    } else if(eventX-downX > 100) { //切换到上一个
      setClickState(false)
			if(list.length > 1) {
				if(isAR) {
				  swiper.current.slideNext()
				} else {
				  swiper.current.slidePrev()
				}
			}
    }
  }

  // 鼠标移出
  const mouseLeave = (e) => {
    setShowDrag(false)
  }

  // 鼠标移入
  const mouseOver = (e) => {
    setShowDrag(true)
  }

  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let domOffsetTop = rootNode.current?.getBoundingClientRect()?.top
    
    if (domOffsetTop < pageHeight / 3 * 2 + 100) {
      setIsActive(true)
    } else {
      setIsActive(false)
    }
  }

  const destroySwiper = () => {
    if (swiper?.current) {
      swiper.current.destroy(true, true)
      swiper.current = null
    }
  }

  useEffect(() => {
    setTimeout((e) => {
      buildSwiper()
    }, 100)

    window.addEventListener("scroll", onScroll)
    return () => {
      destroySwiper()
      window.removeEventListener("scroll", onScroll)
    };
  }, []);
  const btnClick = (item) => {
    gtag('event', 'Component_info', {
      'component_name': 'Modeldisplay',
      'page_title': page?.name
    });
  }
  
  const rootClasses = classNames("c-model-display", list.length < 2 ? 'only' : '', getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <div style={{ backgroundImage: isMobile ? `url(${m_background_image.value.src})` : `url(${pc_background_image.value.src})` }} className="c-model-display-content" ref={rootEl}>
        <div className="title-content">
          {!isMobile && <RichText tag="div" className={["title", isActive ? 'active' : ''].join(' ')} field={pc_title} />}
          {isMobile && <RichText tag="div" className={["title", isActive ? 'active' : ''].join(' ')} field={m_title} />}
          {!isMobile && <RichText tag="div" className={["subtitle", isActive ? 'active' : ''].join(' ')} field={pc_subtitle} />}
          {isMobile && <RichText tag="div" className={["subtitle", isActive ? 'active' : ''].join(' ')} field={m_subtitle} />}
        </div>
        <BackgroundImage {...list[swiperIndex]?.fields?.list[currentArr[swiperIndex]]?.fields?.car_name_image} className="car-name" />
        <div className="c-model-display_swiper swiper" ref={swiperEl}>
          <div className="swiper-wrapper">
            {list && list.map((item, index) => (
              <div className="swiper-slide" key={index}>
                <div className="car-image" style={{ backgroundImage: `url(${item?.fields?.list[currentArr[index]]?.fields?.car_image.value.src})` }}></div>
              </div>
            ))}
          </div>
        </div>
        {list[swiperIndex]?.fields?.list?.length > 1 && <div className="car-name-item-content">
          {
            list[swiperIndex].fields.list && list[swiperIndex].fields.list.map((item, index) => {
              return <div key={index} className={["car-name-item", index === currentArr[swiperIndex] ? 'active' : ''].join(' ')} onClick={(e) => changeCarType(e, index)}>
                <BackgroundImage {...item.fields.car_image} className="small-car-image" />
                <RichText tag="div" className="car-text" field={item.fields.car_name_text} />
              </div>
            })
          }
        </div>}
        <div className={classNames("btn-content", list[swiperIndex]?.fields?.list?.length < 2 ? 'active' : '')}>
          {list[swiperIndex]?.fields?.list[currentArr[swiperIndex]].fields.buttonlist && list[swiperIndex]?.fields?.list[currentArr[swiperIndex]].fields.buttonlist?.length > 0 && list[swiperIndex]?.fields?.list[currentArr[swiperIndex]].fields.buttonlist.map((item, index) => {
            return <div className="primary-button-in" key={index}  onClick={e => btnClick(item.fields)}>
              <PrimaryButton {...{
                  buttonText: item.fields.buttonText,
                  colorScheme: item.fields.colorScheme,
                  iconName: item.fields.iconName,
                  link: {
                    value: {
                      "href": item.fields.link.value.href + "?" + item.fields.link.value.querystring,
                      "text": item.fields.link.value.text,
                      "anchor": item.fields.link.value.anchor,
                      "linktype": item.fields.link.value.linktype,
                      "class": item.fields.link.value.class,
                      "title": item.fields.link.value.title,
                      "target": item.fields.link.value.target,
                      "querystring": item.fields.link.value.querystring,
                      "id": item.fields.link.value.id
                    }
                  }
                }
              } />
            </div>
          })}
        </div>
        {/* m端提示动画 */}
        {isShow && list.length > 1 && <div className="hand-animate-content">
          <BackgroundImage {...left_right_icon} className="left-right-icon" />
          <BackgroundImage {...hand_icon} className="hand-icon" />
        </div>}
        {isShow && list.length > 1 && <RichText tag="div" className="tips" field={tips} />}
        {/* drag */}
         {list.length > 1 && <div className="drag-content-quar" onMouseMove={mousemove} onMouseLeave={mouseLeave} onMouseOver={mouseOver}>
          <div className={["drag-content", showDrag ? 'show' : 'hidden'].join(' ')} onMouseDown={mousedown} onMouseUp={mouseup}>
            <RichText tag="div" className="drag" field={dragtext} />
          </div>
        </div>}
      </div>
    </div>
  )
};
export default Modeldisplay;
